import {
  CentralChatArrowSurface,
} from '@/components/CentralChat/CentralChatArrowSurface';
import { useCentralChatRuntime } from '@/components/CentralChat/centralChatRuntime';

export default function CentralChatPage() {
  const chat = useCentralChatRuntime();

  return (
    <CentralChatArrowSurface
      tenantId={chat.tenantId}
      contextLabel={chat.contextLabel}
      draft={chat.draft}
      status={chat.status}
      isStreaming={chat.isStreaming}
      conversationLoading={chat.conversationLoading}
      activeConversationId={chat.activeConversationId}
      chatAccessMode={chat.chatAccessMode}
      messages={chat.messages}
      conversations={chat.conversations}
      toolActivity={chat.toolActivity}
      turnStartedAt={chat.turnStartedAt}
      modes={chat.modes}
      workflowTiles={chat.workflowTiles}
      helpText={chat.helpText}
      onDraftChange={chat.setDraft}
      onChatAccessModeChange={chat.setChatAccessMode}
      onSubmit={chat.submit}
      onStop={chat.stop}
      onWorkflow={chat.handleWorkflow}
      onMode={chat.handleMode}
      onOpenConversation={chat.openConversation}
      onNewChat={chat.startNew}
      onGoHome={chat.goHome}
      onSandboxOutput={chat.sandboxOutput}
      onSettleWrite={chat.settleWriteApproval}
      onAnswerQuestion={chat.answerQuestion}
    />
  );
}
